export function ColorHintTutorialScreen() {
  return (
    <div className="text-white pb-32">
      <div className="text-2xl text-center">
        <b>Tutorial:</b> Color Hint
      </div>
      <div className="text-center mb-4 px-4 font-extralight">
        Influence the inpainting selection to be a certain color
      </div>
      <video autoPlay loop muted controls>
        <source src="/tutorials/color_hint.mp4" type="video/mp4" />
      </video>
    </div>
  );
}
